import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import validator from 'validator'
import Integrations from "../../integration/Integrations"
import InvoiceHelper from '../../invoice/invoicehelper.jsx'
import InvoiceStatusBadge from "../../invoice/status.component"
import { getEventName } from "../../name-helpers/eventNameHelper"
import { capitalize, pascalCase } from '../../name-helpers/nameFormatter'
import { getPriceListName } from '../../name-helpers/priceListNameHelper'
import OrderHelper from "../../order/orderhelper.jsx"
import OrderStatusBadge from "../../order/status.component"
import PaymentStatus from "../../payment/status.component"
import PriceListHelper from '../../price-list/pricelisthelper.jsx'
import PriceListStatusBadge from "../../price-list/status.component"
import QuoteHelper from '../../quote/quotehelper.jsx'
import QuoteStatusBadge from "../../quote/status.component"
import RoleSystemName from "../../role/systemname.component"
import CalendarEventStatusBadge from "../../scheduling-page/calendareventstatusbadge.component"
import SchedulingHelper from "../../scheduling-page/schedulinghelper.jsx"
import SchedulingPageStatusBadge from "../../scheduling-page/status.component"
import ShopifyAppContext from '../../shopify/shopifyappcontext.js'
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { InventoryLocationService } from "../../state/inventory/location/services"
import { StockDocumentService } from "../../state/inventory/stockdocument/services"
import SectionContentTypes from "../../template/sections/content/ContentTypes.jsx"
import WorkOrderStatusBadge from "../../workorder/status.component.jsx"
import WorkOrderHelper from "../../workorder/workorderhelper.jsx"
import EventBus from '../EventBus.js'
import { StatusBadge } from "../badge"
import Icon from "../icon/icon.component.jsx"
import './header.scss'

class Breadcrumbs extends Component {

    constructor(props, context) {
        super(props, context)
        this.componentName = 'breadcrumbs-component'
        this.state = {
            breadcrumbs: [],
        }
        this.handleEvents = this.handleEvents.bind(this)
        EventBus.listen(EventBus.TopicHistoryChanged, this.componentName, this.handleEvents)
        EventBus.listen(EventBus.TopicRefreshCurrentBreadcrumb, this.componentName, this.handleEvents)
    }

    componentDidMount() {
        this.pushBreadcrumb(window.location.pathname)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.breadcrumbs.length > 0 && ShopifyAppContext.origin) {
            ShopifyAppContext.setBreadcrumbs(this.state.breadcrumbs)
        }
    }

    handleEvents(event) {
        switch (event.getTopic()) {
            case EventBus.TopicRefreshCurrentBreadcrumb:
                let breadcrumbs = this.state.breadcrumbs
                breadcrumbs.pop()
                this.setState({
                    breadcrumbs: breadcrumbs
                }, () => {
                    this.pushBreadcrumb(event.getData().path)
                })

                break
            case EventBus.TopicHistoryChanged:
                this.pushBreadcrumb(event.getData().location.pathname)
        }

    }

    extractInfoFromPathName(pathname) {
        const seg = pathname.split('?')[0].split('/')
        return {
            path: pathname,
            route: seg.map(r => {
                if (validator.isUUID(r) || validator.isHash(r, 'sha1')) {
                    return '{id}'
                } else {
                    return r
                }
            }).join('/'),
            ids: seg.filter(r => (validator.isUUID(r) || validator.isHash(r, 'sha1')))
        }
    }

    addIntegrationMessage(integrationKey) {
        return <FormattedMessage
            id="breadcrumbs.add_integration"
            defaultMessage="Add {integrationKey} integration"
            values={{ integrationKey: Integrations.getIntegrationNameFromKey(integrationKey) }}
        />
    }

    extractBreadcrumbDetail(info) {
        if (info.route.includes('/welcome/')) {
            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.welcome' })
            return Promise.resolve([<span>
                <FormattedMessage
                    id="breadcrumbs.welcome"
                    defaultMessage="Welcome"
                />
            </span>, document.title])
        }

        switch (info.route) {
            case '/':
            case '/dashboard-v2':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.dashboard' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.dashboard"
                    defaultMessage="Dashboard - Current Month"
                />, document.title])
            case '/vend-redirect-subscription':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.vend_redirect_subsciption' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.vend_redirect_subscription"
                    defaultMessage="{integrationKey} Full Trial Activation"
                    values={{ integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.VEND) }}
                />, document.title])
            case '/congrats':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.congratulations' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.congratulations"
                    defaultMessage="Congratulations"
                />, document.title])
            case '/templates/quote-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_quotes' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_quotes"
                    defaultMessage="Quote templates"
                />, document.title])
            case '/templates/contract-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_contracts' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_contracts"
                    defaultMessage="Contract templates"
                />, document.title])
            case '/templates/order-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_orders' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_orders"
                    defaultMessage="Order templates"
                />, document.title])
            case '/templates/invoice-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_invoice' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_invoice"
                    defaultMessage="Invoice templates"
                />, document.title])
            case '/templates/account-statement-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_account_statement' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_account_statement"
                    defaultMessage="Account statement templates"
                />, document.title])
            case '/templates/scheduling-page-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_scheduling_page' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_scheduling_page"
                    defaultMessage="Scheduling page templates"
                />, document.title])
            case '/templates/packing-slip-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_packing_slip' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_packing_slip"
                    defaultMessage="Packing slip templates"
                />, document.title])
            case '/templates/price-list-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.template_price_list' }, {
                    priceList: capitalize(getPriceListName(this.props.intl))
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.template_price_list"
                    defaultMessage="{priceList} templates"
                    values={{
                        priceList: capitalize(getPriceListName(this.props.intl))
                    }}
                />, document.title])
            case '/templates/credit-memo-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_credit_memo_receipt' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_credit_memo_receipt"
                    defaultMessage="Credit memo receipt templates"
                />, document.title])
            case '/templates/snippet/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.snippets' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.snippets"
                    defaultMessage="Snippets"
                />, document.title])
            case '/templates/{id}/edit':
                return AppContext.getApiClient().get('/documents/' + info.ids[0]).then(r => {
                    document.title = r.attributes.name
                    return [<span>{r.attributes.name}</span>, document.title]
                })
            case '/templates/quote-template/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_quotes_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_quotes_new"
                    defaultMessage="New quote template"
                />, document.title])
            case '/templates/order-template/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_orders_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_orders_new"
                    defaultMessage="New order template"
                />, document.title])
            case '/templates/sms-quote-template/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_templates_quotes_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_templates_quotes_new"
                    defaultMessage="New quote template"
                />, document.title])
            case '/templates/sms-order-template/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_templates_orders_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_templates_orders_new"
                    defaultMessage="New order template"
                />, document.title])
            case '/templates/account-statement-template/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_account_statement_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.templates_account_statement_new"
                    defaultMessage="New account statement template"
                />, document.title])
            case '/templates/snippet/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.snippet_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.snippet_new"
                    defaultMessage="New snippet"
                />, document.title])
            case '/templates/{id}/sections/preview':
                return AppContext.getApiClient().get('/documents/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.templates_sections' }, {
                        templateName: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.templates_sections"
                        defaultMessage="Sections of {templateName}"
                        values={{
                            templateName: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/templates/{id}/sections/{id}/edit':
                return AppContext.getApiClient().get('/documents/' + info.ids[0] + '/sections/' + info.ids[1]).then(r => {
                    document.title = SectionContentTypes.getInternalName(r)
                    return [<span>{SectionContentTypes.getInternalName(r)}</span>, document.title]
                })
            case '/templates/{id}/sections/new':
                return AppContext.getApiClient().get('/documents/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.template_new_section' }, {
                        templateName: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.template_new_section"
                        defaultMessage="New section in {templateName}"
                        values={{
                            templateName: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/templates/sms-quote-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_quote' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_quote"
                    defaultMessage="Quote templates"
                />, document.title])
            case '/templates/sms-invoice-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_invoice' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_invoice"
                    defaultMessage="Invoice templates"
                />, document.title])
            case '/templates/sms-order-template/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_order' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_order"
                    defaultMessage="Order templates"
                />, document.title])
            case '/contacts/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.contacts' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.contacts"
                    defaultMessage="Contacts"
                />, document.title])
            case '/companies/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.companies' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.companies"
                    defaultMessage="Companies"
                />, document.title])
            case '/suppliers/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.suppliers' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.suppliers"
                    defaultMessage="Suppliers"
                />, document.title])
            case '/suppliers/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.suppliers.new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.suppliers.new"
                    defaultMessage="New Supplier"
                />, document.title])
            case '/suppliers/{id}/edit':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.suppliers.edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.suppliers.edit"
                    defaultMessage="Edit Supplier"
                />, document.title])
            case '/suppliers/{id}/details':
                return AppContext.getApiClient().get(`/suppliers/${info.ids[0]}`).then(r => {
                    document.title = r.attributes.name
                    return [<span>{r.attributes.name}</span>, document.title]
                })
            case '/contacts/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.contacts.new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.contacts.new"
                    defaultMessage="New contact"
                />, document.title])
            case '/contacts/{id}/details':
                return AppContext.getApiClient().get('/contacts/' + info.ids[0]).then(r => {
                    document.title = r.attributes.name
                    return [<span>{r.attributes.name}</span>, document.title]
                })
            case '/contacts/{id}/edit':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.contacts.edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.contacts.edit"
                    defaultMessage="Edit Contact"
                />, document.title])
            case '/quotes/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.quotes' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.quotes"
                    defaultMessage="Quotes"
                />, document.title])
            case '/matrices/catalog':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.matrices' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.matrices"
                    defaultMessage="Matrices"
                />, document.title])
            case '/products/catalog':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.products' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.products"
                    defaultMessage="Products"
                />, document.title])
            case '/payment-processing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing"
                    defaultMessage="Payment Processing"
                />, document.title])
            case '/payment-processing/payments':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing.payments' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing.payments"
                    defaultMessage="Payments"
                />, document.title])
            case '/payment-processing/payouts':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing.payouts' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing.payouts"
                    defaultMessage="Payouts"
                />, document.title])
            case '/payment-processing/configuration-3ds':
                document.title = this.props.intl.formatMessage({
                    id: 'breadcrumbs.payment_processing.configuration_3ds',
                    defaultMessage: "3D Secure",
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing.configuration_3ds"
                    defaultMessage="3D Secure"
                />, document.title])
            case '/payment-processing/accounts':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing.accounts' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing.accounts"
                    defaultMessage="Accounts"
                />, document.title])
            case '/payment-processing/new-payment-account':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing.new_payment_account' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing.new_payment_account"
                    defaultMessage="New payment account"
                />, document.title])
            case '/stock-documents/{id}/edit':
                return StockDocumentService.get(info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({
                        id: 'breadcrumbs.stock_document_edit',
                        defaultMessage: 'Edit Stock Document',
                    }, {
                        ref: r.attributes.identifier
                    })
                    return [
                        <span>
                            {r.attributes.definition.attributes.name}&nbsp;
                            {r.attributes.identifier}&nbsp;
                            <StatusBadge colorCode={r.attributes.status.attributes.colorCode} text={r.attributes.status.attributes.name} />
                        </span>, document.title]
                })
            case '/payment-processing/terminals':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing.terminals' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing.terminals"
                    defaultMessage="Terminals"
                />, document.title])
            case '/inventory/settings':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inventory_settings' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inventory_settings"
                    defaultMessage="Settings"
                />, document.title])
            case '/inventory/imports':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inventory_imports' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inventory_imports"
                    defaultMessage="Imports"
                />, document.title])
            case '/inventory/imports/{id}/edit':
                return AppContext.getApiClient().get('/inventory-import/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.import_edit' }, {
                        title: r.attributes.identifier
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.import_edit"
                        defaultMessage="Edit {title}"
                        values={{
                            title: r.attributes.identifier
                        }}
                    />, document.title]
                })
            case '/inventory/stock-control':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inventory_stock_control' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inventory_stock_control"
                    defaultMessage="Stock Control"
                />, document.title])
            case '/inventory/document-types':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inventory_document_types' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inventory_document_types"
                    defaultMessage="Document Types"
                />, document.title])
            case '/inventory/stock-locations/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inventory_stock_locations.new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inventory_stock_locations.new"
                    defaultMessage="New stock location"
                />, document.title])
            case '/inventory/stock-locations/{id}/edit':
                return InventoryLocationService.get(info.ids[0]).then(r => {
                    return [r.attributes.name]
                })
            case '/inventory/stock-locations':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inventory_stock_locations.locations' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inventory_stock_locations.locations"
                    defaultMessage="Stock locations"
                />, document.title])
            case '/payment-processing/onboarding':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing_onboarding' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing_onboarding"
                    defaultMessage="Payment Processing Onboarding"
                />, document.title])
            case '/payment-accounts/{paymentAccountId}/edit':
            case '/payment-accounts/{id}/edit':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_processing_onboarding_edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_processing_onboarding"
                    defaultMessage="Payment Processing Onboarding"
                />, document.title])
            case '/bundles':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.bundles' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.bundles"
                    defaultMessage="Bundles"
                />, document.title])
            case '/bundles/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.bundles_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.bundles_new"
                    defaultMessage="New Bundle"
                />, document.title])
            case '/bundles/edit/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.bundles_edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.bundles_edit"
                    defaultMessage="Edit Bundle"
                />, document.title])
            case '/priceLevels/catalog':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.price_levels' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.price_levels"
                    defaultMessage="Price Levels"
                />, document.title])
            case '/priceLevels/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.price_levels_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.price_levels_new"
                    defaultMessage="New Price Level"
                />, document.title])
            case '/priceLevels/edit/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.price_levels_edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.price_levels_edit"
                    defaultMessage="Edit price level"
                />, document.title])
            case '/products/edit/{id}':
                return AppContext.getApiClient().get('/products/' + info.ids[0]).then(r => {
                    switch (r.attributes.type) {
                        case 'single':
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.product_edit' }, {
                                title: r.attributes.title
                            })
                            return [<FormattedMessage
                                id="breadcrumbs.product_edit"
                                defaultMessage="Edit product {title}"
                                values={{
                                    title: r.attributes.title
                                }}
                            />, document.title]
                        case 'matrix-parent':
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.matrix_edit' }, {
                                title: r.attributes.title
                            })
                            return [<FormattedMessage
                                id="breadcrumbs.matrix_edit"
                                defaultMessage="Edit matrix {title}"
                                values={{
                                    title: r.attributes.title
                                }}
                            />, document.title]
                        case 'assembly':
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.assembly_edit' }, {
                                title: r.attributes.title
                            })
                            return [<FormattedMessage
                                id="breadcrumbs.assembly_edit"
                                defaultMessage="Edit bundle {title}"
                                values={{
                                    title: r.attributes.title
                                }}
                            />, document.title]
                    }
                })

            case '/products/edit/{id}/variants/{id}':
                return AppContext.getApiClient().get('/products/' + info.ids[1]).then(r => {
                    return [r.attributes.title]
                })

            case '/products/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.product_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.product_new"
                    defaultMessage="New product"
                />, document.title])
            case '/imports/products':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.product_import' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.product_import"
                    defaultMessage="Product imports"
                />, document.title])
            case '/imports/products-matrix':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.product_matrix_import' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.product_matrix_import"
                    defaultMessage="Matrix imports"
                />, document.title])
            case '/imports/contacts':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.contact_import' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.contact_import"
                    defaultMessage="Contact imports"
                />, document.title])
            case '/imports/suppliers':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.supplier_import' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.supplier_import"
                    defaultMessage="Supplier imports"
                />, document.title])
            case '/matrices/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.matrix_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.matrix_new"
                    defaultMessage="New matrix"
                />, document.title])
            case '/assemblies/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.assembly_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.assembly_new"
                    defaultMessage="New bundle"
                />, document.title])
            case '/relationships/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.relationships' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.relationships"
                    defaultMessage="Relationships"
                />, document.title])
            case '/bottom-line/edit':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.bottom_line' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.bottom_line"
                    defaultMessage="Bottom line"
                />, document.title])
            case '/relationships/edit/{id}':
                return AppContext.getApiClient().get('/relationships/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.relationship_edit' }, {
                        description: r.attributes.description
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.relationship_edit"
                        defaultMessage="Edit {description}"
                        values={{
                            description: r.attributes.description
                        }}
                    />, document.title]
                })
            case '/relationships/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.relationship_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.relationship_new"
                    defaultMessage="New relationship"
                />, document.title])
            case '/settings':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.settings' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.settings"
                    defaultMessage="Settings"
                />, document.title])
            case '/settings/newTax':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.tax_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.tax_new"
                    defaultMessage="New tax"
                />, document.title])
            case '/settings/taxes/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.tax_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.tax_listing"
                    defaultMessage="Taxes"
                />, document.title])
            case '/settings/editTax/{id}':
                return AppContext.getApiClient().get('/taxes/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.tax_edit' }, {
                        name: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.tax_edit"
                        defaultMessage="Edit {name}"
                        values={{
                            name: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/settings/editCompanyDetails':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.company_details' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.company_details"
                    defaultMessage="Edit company details"
                />, document.title])
            case '/settings/editAccountDetails':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.account_details' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.account_details"
                    defaultMessage="Edit account details"
                />, document.title])
            case '/settings/editProposalOptions':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.proposal_options' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.proposal_options"
                    defaultMessage="Edit proposal options"
                />, document.title])
            case '/settings/editTemplateSections/company-presentation':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.proposal_template_company_presentation' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.proposal_template_company_presentation"
                    defaultMessage="Edit company presentation"
                />, document.title])
            case '/settings/editTemplateSections/terms-and-conditions':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.proposal_template_terms_and_conditions' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.proposal_template_terms_and_conditions"
                    defaultMessage="Edit terms and conditions"
                />, document.title])
            case '/settings/editEmailTemplates/send-proposal':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_send_proposal' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_send_proposal"
                    defaultMessage="Edit email send proposal"
                />, document.title])
            case '/settings/editEmailTemplates/send-invoice':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_send_invoice' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_send_invoice"
                    defaultMessage="Edit email send invoice"
                />, document.title])
            case '/settings/editEmailTemplates/send-order':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_send_order' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_send_order"
                    defaultMessage="Edit email send order"
                />, document.title])
            case '/settings/editEmailTemplates/send-account-statement':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_send_account_statement' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_send_account_statement"
                    defaultMessage="Edit email send account statement"
                />, document.title])
            case '/settings/editEmailTemplates/send-credit-memo':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_send_credit_memo_receipt' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_send_credit_memo_receipt"
                    defaultMessage="Edit email template for credit memo receipt"
                />, document.title])
            case '/settings/editEmailTemplates/send-scheduling-page':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.send_scheduling_page_email_template' }, {
                    eventName: getEventName(this.props.intl)
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.send_scheduling_page_email_template"
                    defaultMessage="Edit email template for new {eventName} from scheduling page"
                    values={{ eventName: getEventName(this.props.intl) }}
                />, document.title])
            case '/settings/email-templates/send-proposal/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.quote_email_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.quote_email_template_listing"
                    defaultMessage="Quote email templates listing"
                />, document.title])
            case '/settings/email-templates/send-contract/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.contract_email_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.contract_email_template_listing"
                    defaultMessage="Contract email templates listing"
                />, document.title])
            case '/settings/email-templates/send-order/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.order_email_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.order_email_template_listing"
                    defaultMessage="Order email templates listing"
                />, document.title])
            case '/settings/email-templates/send-invoice/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoice_email_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.invoice_email_template_listing"
                    defaultMessage="Invoice email templates listing"
                />, document.title])
            case '/settings/email-templates/send-scheduling-page/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_listing"
                    defaultMessage="Email templates listing"
                />, document.title])
            case '/settings/email-templates/new-order-from-price-list/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_templates_new_order_from_price_list' }, {
                    priceList: pascalCase(getPriceListName(this.props.intl))
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_templates_new_order_from_price_list"
                    defaultMessage="Order from price list email templates listing"
                    values={{
                        priceList: pascalCase(getPriceListName(this.props.intl))
                    }}
                />, document.title])
            case '/settings/editEmailTemplates/send-scheduling-page/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_email_template"
                    defaultMessage="Create new email template"
                />, document.title])
            case '/settings/editEmailTemplates/send-proposal/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_quote_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_quote_email_template"
                    defaultMessage="Create new quote email template"
                />, document.title])
            case '/settings/editEmailTemplates/send-contract/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_contract_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_contract_email_template"
                    defaultMessage="Create new contract email template"
                />, document.title])
            case '/settings/editEmailTemplates/send-order/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_order_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_order_email_template"
                    defaultMessage="Create new order email template"
                />, document.title])
            case '/settings/editEmailTemplates/send-invoice/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_invoice_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_invoice_email_template"
                    defaultMessage="Create new invoice email template"
                />, document.title])
            case '/settings/editEmailTemplates/new-order-from-price-list/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_order_from_price_list_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_order_from_price_list_email_template"
                    defaultMessage="Create new order from price list email template"
                />, document.title])
            case '/settings/editEmailTemplates/send-booking-confirmation':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_send_booking_confirmation' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_send_booking_confirmation"
                    defaultMessage="Edit email template for booking confirmation"
                />, document.title])
            case '/settings/email-templates/send-booking-confirmation/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_listing"
                    defaultMessage="Email templates listing"
                />, document.title])
            case '/settings/editEmailTemplates/send-booking-confirmation/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_email_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_email_template"
                    defaultMessage="Create new email template"
                />, document.title])
            case '/settings/editEmailTemplatesById/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.email_template_edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.email_template_edit"
                    defaultMessage="Edit email template"
                />, document.title])
            case '/settings/sms-templates/send-sms-quote':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_send_sms_quote' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_send_sms_quote"
                    defaultMessage="Edit SMS template for quote"
                />, document.title])
            case '/settings/sms-templates/send-sms-quote/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.quote_sms_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.quote_sms_template_listing"
                    defaultMessage="Quote SMS templates listing"
                />, document.title])
            case '/settings/editSMSTemplates/send-sms-quote/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_quote_sms_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_quote_sms_template"
                    defaultMessage="Create new quote SMS template"
                />, document.title])
            case '/settings/sms-templates/send-sms-order':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_send_sms_order' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_send_sms_order"
                    defaultMessage="Edit SMS template for order"
                />, document.title])
            case '/settings/sms-templates/send-sms-order/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.order_sms_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.order_sms_template_listing"
                    defaultMessage="Order SMS templates listing"
                />, document.title])
            case '/settings/editSMSTemplates/send-sms-order/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_order_sms_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_order_sms_template"
                    defaultMessage="Create new order SMS template"
                />, document.title])
            case '/settings/sms-templates/send-sms-invoice':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_send_sms_invoice' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_send_sms_invoice"
                    defaultMessage="Edit SMS template for invoice"
                />, document.title])
            case '/settings/sms-templates/send-sms-invoice/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoice_sms_template_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.invoice_sms_template_listing"
                    defaultMessage="Invoice SMS templates listing"
                />, document.title])
            case '/settings/editSMSTemplates/send-sms-invoice/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_invoice_sms_template' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_invoice_sms_template"
                    defaultMessage="Create new invoice SMS template"
                />, document.title])
            case '/settings/editSMSTemplatesById/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.sms_template_edit' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.sms_template_edit"
                    defaultMessage="Edit sms template"
                />, document.title])
            case '/labels/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.labels' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.labels"
                    defaultMessage="Labels"
                />, document.title])
            case '/labels/edit/{id}':
                return AppContext.getApiClient().get('/labels/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.label_edit' }, {
                        title: r.attributes.title
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.label_edit"
                        defaultMessage="Edit {title}"
                        values={{
                            title: r.attributes.title
                        }}
                    />, document.title]
                })
            case '/labels/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.label_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.label_new"
                    defaultMessage="New Label"
                />, document.title])
            case '/calendars/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.calendars' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.calendars"
                    defaultMessage="Calendars"
                />, document.title])
            case '/calendars/edit/{id}':
                return AppContext.getApiClient().get('/calendars/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.calendar_edit' }, {
                        title: r.attributes.title
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.calendar_edit"
                        defaultMessage="Edit {title}"
                        values={{
                            title: r.attributes.title
                        }}
                    />, document.title]
                })
            case '/calendars/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.calendar_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.calendar_new"
                    defaultMessage="New Calendar"
                />, document.title])

            case '/users/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.users' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.users"
                    defaultMessage="Users"
                />, document.title])
            case '/users/edit/{id}':
                return AppContext.getApiClient().get('/users/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.user_edit' }, {
                        name: r.attributes.firstName + ' ' + r.attributes.lastName
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.user_edit"
                        defaultMessage="Edit {name}"
                        values={{
                            name: r.attributes.firstName + ' ' + r.attributes.lastName
                        }}
                    />, document.title]
                })
            case '/users/notification-settings/edit/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.user_edit.notification_settings' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.user_edit.notification_settings"
                    defaultMessage="Email Notifications"
                />, document.title])
            case '/users/signature-settings/edit/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.user_edit.signature_settings' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.user_edit.signature_settings"
                    defaultMessage="Signature"
                />, document.title])
            case '/users/password-settings/edit/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.user_edit.password_settings' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.user_edit.password_settings"
                    defaultMessage="Password Settings"
                />, document.title])
            case '/users/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.user_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.user_new"
                    defaultMessage="New user"
                />, document.title])
            case '/locations/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.locations' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.locations"
                    defaultMessage="Locations"
                />, document.title])
            case '/locations/{id}/edit':
                return AppContext.getApiClient().get('/locations/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.location_edit' }, {
                        name: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.location_edit"
                        defaultMessage="Edit {name}"
                        values={{
                            name: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/locations/template-settings/edit/{id}':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.locations.template_settings' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.locations.template_settings"
                    defaultMessage="Template Settings"
                />, document.title])
            case '/locations/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.location_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.location_new"
                    defaultMessage="New location"
                />, document.title])
            case '/payment-terms/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_terms' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_terms"
                    defaultMessage="Payment terms"
                />, document.title])
            case '/payment-terms/{id}/edit':
                return AppContext.getApiClient().get('/payment-terms/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_term_edit' }, {
                        name: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.payment_term_edit"
                        defaultMessage="Edit {name}"
                        values={{
                            name: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/payment-terms/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_term_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_term_new"
                    defaultMessage="New payment term"
                />, document.title])
            case '/payment-types/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_types' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_types"
                    defaultMessage="Payment types"
                />, document.title])
            case '/payment-types/{id}/edit':
                return AppContext.getApiClient().get('/payment-types/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_type_edit' }, {
                        name: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.payment_type_edit"
                        defaultMessage="Edit {name}"
                        values={{
                            name: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/payment-types/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_type_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payment_type_new"
                    defaultMessage="New payment type"
                />, document.title])
            case '/order-statuses/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.order_statuses' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.order_statuses"
                    defaultMessage="Order statuses"
                />, document.title])
            case '/order-statuses/{id}/edit':
                return AppContext.getApiClient().get('/order-statuses/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.order_status_edit' }, {
                        name: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.order_status_edit"
                        defaultMessage="Edit status {name}"
                        values={{
                            name: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/order-statuses/ordered/new/1':
            case '/order-statuses/ordered/new/2':
            case '/order-statuses/ordered/new/3':
            case '/order-statuses/ordered/new/4':
            case '/order-statuses/ordered/new/5':
            case '/order-statuses/ordered/new/6':
            case '/order-statuses/completed/new/1':
            case '/order-statuses/completed/new/2':
            case '/order-statuses/completed/new/3':
            case '/order-statuses/completed/new/4':
            case '/order-statuses/completed/new/5':
            case '/order-statuses/completed/new/6':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.order_status_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.order_status_new"
                    defaultMessage="New order status"
                />, document.title])
            case '/roles/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.roles_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.roles_new"
                    defaultMessage="New role"
                />, document.title])
            case '/roles/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.roles' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.roles"
                    defaultMessage="Roles"
                />, document.title])
            case '/roles/{id}/edit':
                return AppContext.getApiClient().get('/roles/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.role_edit' }, {
                        name: r.attributes.key
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.role_edit"
                        defaultMessage="Edit {name} role"
                        values={{
                            name: <RoleSystemName value={r.attributes.key} />
                        }}
                    />, document.title]
                })
            case '/quotes/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.quote_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.quote_new"
                    defaultMessage="New quote"
                />, document.title])
            case '/quotes/{id}/edit':
                return AppContext.getApiClient().get('/quotes/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.quote_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.quote_edit"
                            defaultMessage="Edit quote {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        &nbsp;
                        <QuoteStatusBadge status={r.attributes.status} internal={true} className="pl-1" />
                        {
                            r.attributes.liveQuoteStatus === 'running' &&
                            <span
                                className={"badge badge-danger ml-2"} onClick={this.closeEditMode}>
                                <Icon value={"circle"} className={""} />
                                <FormattedMessage
                                    id="quote.edit.live_quote_badge"
                                    defaultMessage="Live mode"
                                />
                            </span>
                        }
                    </span>, `${document.title} (${QuoteHelper.getStatusName(this.props.intl, r.attributes.status, true)})`]
                })
            case '/quotes/create-from/{id}/{id}':
                return AppContext.getApiClient().get('/quotes/' + info.ids[1]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.create_from_quote' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.create_from_quote"
                            defaultMessage="Create from {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                    </span>, document.title]
                })
            case '/orders/{id}/edit':
                return AppContext.getApiClient().get('/orders/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.order_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.order_edit"
                            defaultMessage="Order {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        &nbsp;
                        <OrderStatusBadge statusId={r.attributes.customStatusId} className="pl-1" />
                    </span>, `${document.title} (${OrderHelper.getStatusName(r.attributes.customStatusId)})`]
                })
            case '/orders/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.orders' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.orders"
                    defaultMessage="Orders"
                />, document.title])
            case '/orders/item-report':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.orders_report' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.orders_report"
                    defaultMessage="Item Report"
                />, document.title])
            case '/invoices/{id}/edit':
                return AppContext.getApiClient().get('/invoices/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoice_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.invoice_edit"
                            defaultMessage="Invoice {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        <InvoiceStatusBadge status={r.attributes.status} className={'ml-2'} />
                    </span>, `${document.title} (${InvoiceHelper.getStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/invoices/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoices' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.invoices"
                    defaultMessage="Invoices"
                />, document.title])
            case '/payments/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payments' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.payments"
                    defaultMessage="Payments"
                />, document.title])
            case '/payments/{id}/edit':
                return AppContext.getApiClient().get('/payments/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.payment_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.payment_edit"
                            defaultMessage="Payment {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        &nbsp;
                        <PaymentStatus value={r.attributes.status} className="pl-1" />
                    </span>, `${document.title} (${OrderHelper.getStatusName(r.attributes.customStatusId)})`]
                })
            case '/sales/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoices_sales' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.invoices_sales"
                    defaultMessage="Lightspeed Sales"
                />, document.title])
            case '/receipts/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoices_receipts' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.invoices_receipts"
                    defaultMessage="Receipts"
                />, document.title])
            case '/price-lists/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.price_list' }, {
                    priceList: pascalCase(getPriceListName(this.props.intl))
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.price_list"
                    defaultMessage="{priceList}s"
                    values={{
                        priceList: capitalize(getPriceListName(this.props.intl))
                    }}
                />, document.title])
            case '/price-lists/{id}/edit':
                return AppContext.getApiClient().get('/price-lists/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.price_lists_edit' }, {
                        ref: r.attributes.identifier,
                        priceList: pascalCase(getPriceListName(this.props.intl))
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.price_lists_edit"
                            defaultMessage="{priceList} {ref}"
                            values={{
                                ref: r.attributes.identifier,
                                priceList: pascalCase(getPriceListName(this.props.intl))
                            }}
                        />
                        <PriceListStatusBadge
                            status={r.attributes.status}
                            isDisabled={r.attributes.isDisabled}
                            className={'ml-2'}
                        />
                    </span>, `${document.title} (${PriceListHelper.getStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/scheduling-pages/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.scheduling_pages' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.scheduling_pages"
                    defaultMessage="Scheduling pages"
                />, document.title])
            case '/calendar-events/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.calendar_events.new' }, {
                    eventName: getEventName(this.props.intl)
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.calendar_events.new"
                    defaultMessage="New calendar {eventName}"
                    values={{ eventName: getEventName(this.props.intl) }}
                />, document.title])
            case '/calendar-events/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.events_listing' }, {
                    eventName: capitalize(getEventName(this.props.intl))
                })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.events_listing"
                    defaultMessage="{eventName}s"
                    values={{ eventName: capitalize(getEventName(this.props.intl)) }}
                />, document.title])
            case '/calendar-events/{id}/edit':
                return AppContext.getApiClient().get('/calendar-events/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.calendar_events_edit' }, {
                        ref: r.attributes.identifier,
                        eventName: capitalize(getEventName(this.props.intl))
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.calendar_events_edit"
                            defaultMessage="{eventName} {ref}"
                            values={{
                                ref: r.attributes.identifier,
                                eventName: capitalize(getEventName(this.props.intl))
                            }}
                        />
                        <CalendarEventStatusBadge status={r.attributes.status} className={'ml-2'} />
                    </span>, `${document.title} (${SchedulingHelper.getCalendarEventStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/scheduling-pages/{id}/edit':
                return AppContext.getApiClient().get('/scheduling-pages/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.scheduling_page_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.scheduling_page_edit"
                            defaultMessage="Scheduling page {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        <SchedulingPageStatusBadge status={r.attributes.status} className={'ml-2'} />
                    </span>, `${document.title} (${SchedulingHelper.getSchedulingPageStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/invoices/ageing-report':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoices_ageing_report' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.invoices_ageing_report"
                    defaultMessage="Invoices ageing report"
                />, document.title])
            case '/recurring-invoices/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.recurring_invoices' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.recurring_invoices"
                    defaultMessage="Recurring invoices"
                />, document.title])
            case '/returns/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.returns' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.returns"
                    defaultMessage="Returns"
                />, document.title])
            case '/credit-memos/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.credit_memos' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.credit_memos"
                    defaultMessage="Credit Memos"
                />, document.title])
            case '/returns/{id}/edit':
                return AppContext.getApiClient().get('/invoices/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.return_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.return_edit"
                            defaultMessage="Return {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        <InvoiceStatusBadge status={r.attributes.status} className={'ml-2'} />
                    </span>, `${document.title} (${InvoiceHelper.getStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/custom-field-definitions/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.custom_fields' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.custom_fields"
                    defaultMessage="Custom fields"
                />, document.title])
            case '/custom-field-definitions/edit/{id}':
                return AppContext.getApiClient().get('/custom-field-definitions/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.custom_field_edit' }, {
                        name: r.attributes.name
                    })
                    return [<FormattedMessage
                        id="breadcrumbs.custom_field_edit"
                        defaultMessage="Edit {name}"
                        values={{
                            name: r.attributes.name
                        }}
                    />, document.title]
                })
            case '/custom-field-definitions/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.custom_field_new' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.custom_field_new"
                    defaultMessage="New custom field"
                />, document.title])
            case '/account-statements/{id}/edit':
                return AppContext.getApiClient().get('/account-statements/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({
                        id: 'breadcrumbs.account_statement_edit',
                        defaultMessage: "Account Statements"
                    }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.account_statement_edit"
                            defaultMessage="Account statement {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                    </span>, `${document.title} (${InvoiceHelper.getStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/proposals/{id}/preview':
                return AppContext.getApiClient().get('/proposals/' + info.ids[0]).then(r => {
                    switch (r.attributes.variables.document.type) {
                        case "invoice":
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.invoice_preview' }, {
                                reference: r.attributes.variables.document.reference
                            })
                            return [<FormattedMessage
                                id="breadcrumbs.invoice_preview"
                                defaultMessage="Invoice preview {reference}"
                                values={{
                                    reference: r.attributes.variables.document.reference
                                }}
                            />, document.title]
                        case "account-statement":
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.account_statement_preview' })
                            return [<FormattedMessage
                                id="breadcrumbs.account_statement_preview"
                                defaultMessage="Account statement preview"
                            />, document.title]
                        case "scheduling-page":
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.scheduling_page_preview' })
                            return [<FormattedMessage
                                id="breadcrumbs.scheduling_page_preview"
                                defaultMessage="Scheduling page preview"
                            />, document.title]
                        case "stock-document":
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.stock_document_preview' }, {
                                reference: r.attributes.variables.document.reference
                            })
                            return [<FormattedMessage
                                id="breadcrumbs.stock_document_preview"
                                defaultMessage="{name} preview {reference}"
                                values={{
                                    name: r.attributes.variables.quote.documentName,
                                    reference: r.attributes.variables.document.reference
                                }}
                            />, document.title]
                        case "packing-slip":
                            document.title = this.props.intl.formatMessage({ id: "breadcrumbs.proposal.packing_slip_preview" }, {
                                reference: r.attributes.variables.quote.reference
                            })
                            return [<FormattedMessage
                                id="'breadcrumbs.proposal.packing_slip_preview'"
                                defaultMessage="Packing slip for {reference}"
                                values={{
                                    reference: r.attributes.variables.quote.reference
                                }}
                            />, document.title]
                        default:
                            document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.proposal_preview' }, {
                                reference: r.attributes.variables.quote.reference
                            })
                            return [<FormattedMessage
                                id="breadcrumbs.proposal_preview"
                                defaultMessage="Quote preview {reference}"
                                values={{
                                    reference: r.attributes.variables.quote.reference
                                }}
                            />, document.title]
                    }
                })
            case '/integrations/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.integrations' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.integrations"
                    defaultMessage="Integrations"
                />, document.title])
            case '/integrations/new/d-tools':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_d_tools' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_d_tools"
                    defaultMessage="Add D-Tools SI integration"
                />, document.title])
            case '/integrations/new/paysafe':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_paysafe' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_paysafe"
                    defaultMessage="Add Paysafe integration"
                />, document.title])
            case '/integrations/new/hubspot':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_hubspot' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_hubspot"
                    defaultMessage="Add Hubspot integration"
                />, document.title])
            case '/integrations/new/quick-books':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_quickbooks' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.QUICK_BOOKS), document.title])
            case '/integrations/new/outlook':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_outlook' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_outlook"
                    defaultMessage="Add Outlook integration"
                />, document.title])
            case '/integrations/new/ls-retail':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_lightspeed' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.LIGHTSPEED_RETAIL), document.title])
            case '/integrations/new/vend':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_vend' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.VEND), document.title])
            case '/integrations/new/wix':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_wix' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.WIX), document.title])
            case '/integrations/new/shopify':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_shopify' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.SHOPIFY), document.title])
            case '/integrations/new/stripe':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_stripe' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.STRIPE), document.title])
            case '/integrations/new/square':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_square' })
                return Promise.resolve([this.addIntegrationMessage(INTEGRATION_KEY.SQUARE), document.title])
            case '/integrations/new/custom-smtp':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_custom_smtp' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_custom_smtp"
                    defaultMessage="Add SMTP integration"
                />, document.title])
            case '/integrations/new/zapier-mu2':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_zapier_mu2' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_zapier_mu2"
                    defaultMessage="Add Zapier integration"
                />, document.title])
            case '/integrations/new/zapier':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_zapier' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_zapier"
                    defaultMessage="Add Zapier integration"
                />, document.title])
            case '/integrations/new/zendesk-support-mu2':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_zendesk_support_mu2' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_zendesk_support_mu2"
                    defaultMessage="Add Zendesk Support integration"
                />, document.title])
            case '/integrations/new/kangaroo':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_kangaroo' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_kangaroo"
                    defaultMessage="Add Kangaroo integration"
                />, document.title])
            case '/integrations/new/zendesk-sell':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_zendesk_sell' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_zendesk_sell"
                    defaultMessage="Add Zendesk Sell integration"
                />, document.title])
            case '/integrations/new/ls-golf':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_ls_golf' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_ls_golf"
                    defaultMessage="Add Lightspeed Golf integration"
                />, document.title])
            case '/integrations/new/square-payments':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_square_payments' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_square_payments"
                    defaultMessage="Add Square Payments integration"
                />, document.title])
            case `/integrations/new/${INTEGRATION_KEY.PIPEDRIVE}`:
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_pipedrive' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_pipedrive"
                    defaultMessage="Add Pipedrive integration"
                />, document.title])
            case `/integrations/new/${INTEGRATION_KEY.ZENDESK_SUPPORT}`:
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_zendesk_support' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_zendesk_support"
                    defaultMessage="Add Zendesk Support integration"
                />, document.title])
            case `/integrations/new/${INTEGRATION_KEY.MAILCHIMP}`:
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.add_integration_mailchimp' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.add_integration_mailchimp"
                    defaultMessage="Add Mailchimp integration"
                />, document.title])
            case '/integrations/edit/{id}':
                return AppContext.getApiClient().get('/integration-configurations/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.edit_integration' })
                    switch (r.attributes.integrationKey) {
                        case 'd-tools':
                            return [<FormattedMessage
                                id="breadcrumbs.edit_integration_d_tools"
                                defaultMessage="Edit D-Tools SI integration"
                            />, document.title]
                        default:
                            return [<FormattedMessage
                                id="breadcrumbs.edit_integration"
                                defaultMessage="Edit integration"
                            />, document.title]
                    }

                })
            case '/work-orders/{id}/edit':
                return AppContext.getApiClient().get('/work-orders/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.work_order_edit' }, {
                        ref: r.attributes.identifier
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.work_order_edit"
                            defaultMessage="Edit work order {ref}"
                            values={{
                                ref: r.attributes.identifier
                            }}
                        />
                        &nbsp;
                        <WorkOrderStatusBadge status={r.attributes.status} className="pl-1" />
                    </span>, `${document.title} (${WorkOrderHelper.getStatusName(this.props.intl, r.attributes.status)})`]
                })
            case '/work-orders/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.work_orders' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.work_orders"
                    defaultMessage="Work orders"
                />, document.title])
            case '/my-account':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.my_account' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.my_account"
                    defaultMessage="My Account"
                />, document.title])
            case '/branding':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.branding' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.branding"
                    defaultMessage="Branding"
                />, document.title])
            case '/workflows/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.workflows' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.workflows"
                    defaultMessage="Automation"
                />, document.title])
            case '/workflows/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_workflow' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_workflow"
                    defaultMessage="New automation"
                />, document.title])

            case '/workflows/{id}/edit':
                return AppContext.getApiClient().get('/workflows/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.workflow_edit' }, {
                        ref: r.attributes.name
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.workflow_edit"
                            defaultMessage="Edit automation {ref}"
                            values={{
                                ref: r.attributes.name
                            }}
                        />
                    </span>, document.title]
                })
            case '/redirect/zendesk-sell/create-quote-order':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.create_quote_from_zendesk_sell' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.create_quote_from_zendesk_sell"
                    defaultMessage="Create Zendesk Sell"
                />, document.title])
            case '/settings/fees/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.fee_listing' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.fee_listing"
                    defaultMessage="Fees"
                />, document.title])
            case '/settings/fees/new':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.new_fee' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.new_fee"
                    defaultMessage="New fee"
                />, document.title])
            case '/settings/fees/{id}/edit':
                return AppContext.getApiClient().get('/fees/' + info.ids[0]).then(r => {
                    document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.fee_edit' }, {
                        ref: r.attributes.name
                    })
                    return [<span>
                        <FormattedMessage
                            id="breadcrumbs.fee_edit"
                            defaultMessage="Edit fee {ref}"
                            values={{
                                ref: r.attributes.name
                            }}
                        />
                    </span>, document.title]
                })
            case '/inbox/listing':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.inbox' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.inbox"
                    defaultMessage="Inbox"
                />, document.title])

            case '/ecommerce-configuration/quote-cart':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.ecommerce_configuration' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.ecommerce_configuration"
                    defaultMessage="Ecommerce Configuration"
                />, document.title])
            case '/nylas-migration':
                document.title = this.props.intl.formatMessage({ id: 'breadcrumbs.nylas_migration_page' })
                return Promise.resolve([<FormattedMessage
                    id="breadcrumbs.nylas_migration_page"
                    defaultMessage="Action Required"
                />, document.title])
            default:
                return Promise.resolve([info.route, document.title])
        }

    }

    shouldReset(route) {
        switch (route) {
            case '/':
            case '/contacts/listing':
            case '/quotes/listing':
            case '/matrices/catalog':
            case '/products/catalog':
            case '/payment-processing':
            case '/payment-processing/payments':
            case '/payment-processing/payouts':
            case '/payment-processing/configuration-3ds':
            case '/payment-processing/accounts':
            case '/payment-processing/terminals':
            case '/inventory/settings':
            case '/bundles':
            case '/bundles/new':
            case '/bundles/edit/{id}':
            case '/priceLevels/catalog':
            case '/priceLevels/new':
            case '/priceLevels/edit/{id}':
            case '/relationships/listing':
            case '/bottom-line/edit':
            case '/settings':
            case '/labels/listing':
            case '/calendars/listing':
            case '/custom-field-definitions/listing':
            case '/models/listing':
            case '/users/listing':
            case '/users/edit/{id}':
            case '/users/notification-settings/edit/{id}':
            case '/users/signature-settings/edit/{id}':
            case '/users/password-settings/edit/{id}':
            case '/integrations/listing':
            case '/work-orders/listing':
            case '/orders/listing':
            case '/orders/report':
            case '/price-lists/listing':
            case '/calendar-events/listing':
            case '/invoices/listing':
            case '/payments/listing':
            case '/payements/{id}/edit':
            case '/recurring-invoices/listing':
            case '/workflows/listing':
            case '/branding':
            case '/templates/invoice-template/listing':
            case '/templates/order-template/listing':
            case '/templates/account-statement-template/listing':
            case '/templates/scheduling-page-template/listing':
            case '/templates/packing-slip-template/listing':
            case '/templates/credit-memo-template/listing':
            case '/templates/quote-template/listing':
            case '/templates/sms-quote-template/listing':
            case '/templates/sms-invoice-template/listing':
            case '/templates/sms-order-template/listing':
            case '/templates/contract-template/listing':
            case '/templates/{id}/sections/preview':
            case '/inbox/listing':
            case '/dashboard-v2':
            case '/vend-redirect-subscription':
            case '/welcome/{stepId}':
            case '/nylas-migration':
                return true
            default:
                return false
        }
    }

    hasLink(route) {
        switch (route) {
            case '/redirect/zendesk-sell/create-quote-order':
                return false
            default:
                return true
        }
    }

    pushBreadcrumb(pathname) {
        const info = this.extractInfoFromPathName(pathname)

        this.extractBreadcrumbDetail(info).then(res => {
            let textComponent = res[0]
            let textString = res[1]

            let breadcrumbs = this.state.breadcrumbs
            if (this.shouldReset(info.route)) {
                breadcrumbs = []
            }
            const currentBreadcrumb = breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1] : null
            const hasLink = this.hasLink(info.path)
            if (currentBreadcrumb && currentBreadcrumb.link === info.path) {
                breadcrumbs[breadcrumbs.length - 1] = {
                    link: info.path,
                    text: textComponent,
                    stringLabel: textString,
                    hasLink: hasLink,
                }
            } else {
                breadcrumbs.push({
                    link: info.path,
                    text: textComponent,
                    stringLabel: textString,
                    hasLink: hasLink,
                })
            }

            if (breadcrumbs.length > 3) {
                breadcrumbs.shift()
            }

            // Case for Product Matrix / Variants edit only
            if (breadcrumbs.length === 3 &&
                breadcrumbs[1].link.includes('variants') &&
                breadcrumbs[0].link === breadcrumbs[breadcrumbs.length - 1].link) {
                const parentElement = breadcrumbs.shift()
                breadcrumbs = []
                breadcrumbs.push(parentElement)
            }


            this.setState({
                breadcrumbs: breadcrumbs
            })
        })
    }

    handleBreadcrumbClick(link, index) {
        return function (e) {
            e.preventDefault()
            let breadcrumbs = this.state.breadcrumbs
            this.setState({
                breadcrumbs: breadcrumbs.filter((b, i) => i < index)
            }, () => {
                EventBus.dispatch(EventBus.TopicHistoryPush, {
                    path: link,
                })
            })
        }.bind(this)
    }

    render() {
        if (this.props.isHidden) {
            return ''
        }

        return (
            <h6 className="font-weight-normal pl-0 my-0">
                <Link to="/"><Icon value={"home"} /></Link>
                {this.state.breadcrumbs.map((b, i) => {
                    let title = <a href="#" onClick={this.handleBreadcrumbClick(b.link, i)}>
                        {b.text}
                    </a>
                    if (i === (this.state.breadcrumbs.length - 1) || !b.hasLink) {
                        title = b.text
                    }
                    return <span key={i}>
                        &nbsp;
                        <Icon value="chevron-right" />
                        &nbsp;
                        {title}
                    </span>
                })}
            </h6>
        );
    }
}

export default injectIntl(Breadcrumbs)


// WEBPACK FOOTER //
// ./src/common/layout/breadcrumbs.component.jsx